import { getChildLogger } from "@toolprint/sdk";

const providersLogLevel = () => {
  return (
    process.env.ONEGREP_PROVIDERS_LOG_LEVEL ?? process.env.LOG_LEVEL ?? "info"
  );
};

// The child logger for the CLI, which uses the env vars or defaults
const getLogger = () => {
  return getChildLogger("providers", providersLogLevel());
};

export const logger = getLogger();
